import { FC } from 'react';
import { Button, Group, InlineNotification } from '@logz-ui/styleguide';
import styled from 'styled-components';
import { hideModalInNewApp } from 'ui/utils/hide-modal-in-new-app';
import { analyticsService } from 'services/analytics/analytics.service';
import { useIsNewAppEnabled } from 'ui/hooks/is-new-application-enabled.hook';
import { useRouter } from 'ui/hooks';
import { useNewAppToggle } from 'ui/components/GeneralSettings/NewAppRow/new-app-toggle.hook';

const StyledNotification = styled(InlineNotification)`
  align-self: center;
  display: flex;
  padding: 8px;
  div {
    align-items: center;
  }
`;

interface ISneakPeakBannerProps {
  allowedStates?: string[];
  textComponent?: React.ReactNode;
}

export const SneakPeakBanner: FC<ISneakPeakBannerProps> = ({ allowedStates, textComponent }) => {
  const { isNewAppEnabled } = useIsNewAppEnabled();
  const { currentState } = useRouter();
  const { isPending } = useNewAppToggle();

  if (!allowedStates?.some(state => currentState?.includes(state)) || isNewAppEnabled) return null;

  return (
    <StyledNotification
      variant={'announcement'}
      shouldCenterIcon
      title={
        <Group alignItems="center" justifyContent="center">
          {textComponent}
          <Button
            disabled={isPending}
            size="xs"
            variant="contrast"
            target="_blank"
            href={`${window.location.origin}/360`}
            onClick={() => {
              hideModalInNewApp();
              analyticsService.capture(
                'Open 360 application migration',
                `Clicked on sneak peek to new application experience from explore banner`,
              );
            }}
          >
            Sneak peek
          </Button>
        </Group>
      }
      noClose
      fullWidth
    />
  );
};
